<div class="com-created-popup">
    <div class="modal">
        <div class="icon-wrapper">
            <img src="../../../../../../../assets/billing-icon-alert.svg" alt="icon-info" />
        </div>
        <div class="main-content-wrapper">
            <div class="text-wrapper">
                <span class="title">{{title}}</span>
                <p class="text">{{subTitle}}</p>
            </div>
        </div>
        <div class="button-wrapper">
            @if(is_showBack){
            <button class="back-to-home" (click)="handleLater()">
                <span class="text-btn">Upgrade Later</span>
            </button>
            }
            <button class="manage-access" (click)="handleUpgrade()">
                <span class="btn-text">
                    Upgrade Plan
                </span>
            </button>
        </div>
    </div>
</div>